import React from 'react';
import PropTypes from 'prop-types';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { AccountPaymentStatusPanel } from 'web-ui-components/lib/finance/accounts';

const BacsStatusBlock = ({
	type,
	title,
	children,
	showAuthoriserButton,
	sidebarStatus,
	openAuthoriserModal,
	authoriserButtonText,
}) => {
	const getContent = (
		<div>
			{children}
			{sidebarStatus && <p className="u-text-align-center">{sidebarStatus}</p>}
			{showAuthoriserButton && (
				<NavigationButton.Tertiary
					data-test-id="bacs-view-authorisers-button"
					isInline
					labelText={authoriserButtonText}
					onClick={openAuthoriserModal}
				/>
			)}
		</div>
	);

	switch (type) {
		case 'authorisation':
			return (
				<AccountPaymentStatusPanel.Authorisation titleText={title}>
					{getContent}
				</AccountPaymentStatusPanel.Authorisation>
			);
		case 'submitted':
			return <AccountPaymentStatusPanel.Success titleText={title}>{getContent}</AccountPaymentStatusPanel.Success>;
		case 'failed':
			return <AccountPaymentStatusPanel.Failure titleText={title}>{getContent}</AccountPaymentStatusPanel.Failure>;
		default:
			return '';
	}
};

BacsStatusBlock.propTypes = {
	type: PropTypes.oneOf(['authorisation', 'submitted', 'failed']),
	/** Text string for the value */
	title: PropTypes.string.isRequired,
	/** Can be text or other components */
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	sidebarStatus: PropTypes.string,
	openAuthoriserModal: PropTypes.func,
	authoriserButtonText: PropTypes.string,
	showAuthoriserButton: PropTypes.bool,
};

BacsStatusBlock.defaultProps = {};

export default BacsStatusBlock;
